import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth.service';
import { concatMap, filter, from, of } from 'rxjs';
import {
  AUTH_ROUTES,
  EXERCISE_LIBRARY_ROUTES,
} from '../../../shared/constants/routes.constants';
import { USER_TYPES } from '../../firestore/collections/users/users-collection.constants';

export const guestChildGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isInitialized$.pipe(
    filter(isInitialized => isInitialized),
    concatMap(() => from(authService.getUserType())),
    concatMap(userType => {
      if (authService.isSignedIn) {
        const segments = route.url.map((segment) => segment.path);
        if (segments.includes(AUTH_ROUTES.RELATIVE.SIGN_OUT)) return of(true);

        const isSignInPage = segments.includes(AUTH_ROUTES.RELATIVE.SIGN_IN);

        if (!userType && isSignInPage) return of(true);
        if (!userType) return from(router.navigate(AUTH_ROUTES.ROUTER_LINK.SIGN_IN));
        else if (userType === USER_TYPES.SUPPORT) {
          return from(router.navigate(EXERCISE_LIBRARY_ROUTES.ROUTER_LINK.LIST));
        } else return from(router.navigate(EXERCISE_LIBRARY_ROUTES.ROUTER_LINK.LIST));
      }

      return of(true);
    })
  );
};
